import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Seo from '../components/Seo';
import PageHero from '../components/PageHero';
import Reveal from '../components/Reveal';
import BookingForm from '../components/BookingForm';
import { ArrowRight, Clock, Phone, Pin, Starburst } from '../components/Icons';
import { LOCATIONS, IZI, getLocation } from '../data/site';
import { PHOTO } from '../data/media';
import './Form.css';

export default function Bookings() {
  const [params] = useSearchParams();
  const preset = getLocation(params.get('branch'));
  const branch = preset || LOCATIONS[0];

  return (
    <>
      <Seo
        title="Book a table"
        description="Reserve a table at The Local, Bugolobi or Kyanja. Tell us the date, the time and how many of you there are — we'll confirm by phone or email."
        path="/bookings"
      />

      <PageHero
        eyebrow="Reservations"
        title="Book a table."
        lead="Tell us when and how many. We'll come back to confirm — usually within the hour during service."
        image={PHOTO.plate1}
      />

      <section className="section formpanel">
        <div className="page formpanel__grid">
          <div className="formpanel__main">
            <BookingForm defaultBranch={preset?.name} />
          </div>

          <aside className="formaside">
            <Reveal className="formaside__card" delay={0.1}>
              <Starburst size={34} />
              <h3 className="display brand d4">Booking in a hurry?</h3>
              <p className="formaside__body">
                For same-day tables and groups over twelve, calling is faster than the
                form — the host answers the phone at the pass.
              </p>
              <ul className="formaside__list">
                {LOCATIONS.map((l) => (
                  <li key={l.id}>
                    <Phone size={14} />
                    <a href={`tel:${l.phoneIntl}`}>
                      <strong>{l.name}</strong> <span className="tabular">{l.phone}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </Reveal>

            <Reveal className="formaside__card" delay={0.18}>
              <h3 className="display brand d4">{branch.name}</h3>
              <p className="formaside__body italic">{branch.strapline}</p>
              <ul className="formaside__list">
                <li>
                  <Pin size={14} />
                  <a href={branch.mapUrl} target="_blank" rel="noopener noreferrer">
                    {branch.area}
                  </a>
                </li>
                {branch.hours.map((h) => (
                  <li key={h.days}>
                    <Clock size={14} />
                    <span>
                      {h.days} <span className="tabular">{h.time}</span>
                    </span>
                  </li>
                ))}
              </ul>
            </Reveal>

            <Reveal className="formaside__card formaside__card--dark" delay={0.26}>
              <h3 className="display brand d4">Staying in instead?</h3>
              <p className="formaside__body">{IZI.blurb}</p>
              <a
                className="btn btn--gold btn--sm"
                href={IZI.web}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>Order on {IZI.brand}</span>
                <ArrowRight />
              </a>
            </Reveal>
          </aside>
        </div>
      </section>
    </>
  );
}
